// Product display helpers for the AERWEAR storefront.

// Format: COLOR | PRODUCT NAME (e.g. "BLACK | RACER JERSEY").
// When a product has no color, show only the name (no misleading "BLACK |").
export function formatProductName(product) {
  if (!product) return "";
  const color = product.colors?.[0]?.name;
  const name = (product.name || "").toUpperCase();
  return color ? `${color.toUpperCase()} | ${name}` : name;
}

// Format a cart line item (which stores name + color flat, not a colors array).
export function formatCartName(item) {
  if (!item) return "";
  const name = (item.name || "").toUpperCase();
  return item.color ? `${String(item.color).toUpperCase()} | ${name}` : name;
}

// Struck-through "original" price for the 20%-off presentation (current price + 20%).
export function comparePrice(price) {
  if (!price && price !== 0) return 0;
  return price * 1.2;
}

const isShopifyCdn = (url) => typeof url === "string" && /cdn\.shopify\.com|myshopify\.com|\/cdn\//.test(url);

// Append Shopify CDN resize params so mobile/cards don't download full-res images.
// Shopify's CDN picks WebP or AVIF itself from the browser's Accept header.
export function shopifyImg(url, width = 800) {
  if (!isShopifyCdn(url)) return url;
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}width=${width}`;
}

// srcset at several widths so each screen downloads close to its displayed size.
export function shopifySrcSet(url, widths = [360, 540, 720, 1080]) {
  if (!isShopifyCdn(url)) return undefined;
  return widths.map((w) => `${shopifyImg(url, w)} ${w}w`).join(", ");
}

// Common `sizes` values for the grids used on the site.
export const SIZES_GRID_4 = "(min-width: 1024px) 23vw, 46vw";
export const SIZES_PDP_MAIN = "(min-width: 768px) 50vw, 100vw";

// Descriptive alt text, e.g. "AERWEAR Black Racer Track Pant, front view."
export function productAlt(product, view = "front view") {
  if (!product) return "AERWEAR product";
  const color = product.colors?.[0]?.name || "";
  return `AERWEAR ${color} ${product.name || ""}, ${view}.`.replace(/\s+/g, " ").trim();
}
